// extracted by mini-css-extract-plugin
export var chip = "_ds-0";
export var filterDropdown = "_ds-5";
export var filterItem = "_ds-6";
export var icon = "_ds-1";
export var removeButton = "_ds-3";
export var removeIcon = "_ds-4";
export var separator = "_ds-2";